import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export var getDefaultStyleSheet = _ref => {
  var {
    aside,
    disabled,
    description,
    designContext,
    hasDegradedPerformance,
    isFirst,
    isLast,
    isSingleLine,
    omitLastLine,
    omitFirstLine,
    hasContentPadding,
    hideBullet,
    shouldPaddingLeftBullet
  } = _ref;
  var descriptionTextColor = designContext.get('radio/description-text-color', {
    interactiveState: disabled ? 'disabled' : 'default'
  }).toString();
  var descriptionTextStyle = designContext.get('radio/description-text-style').styles();
  return {
    rootStyle: {
      borderColor: designContext.get('radio/border-color').toString(),
      borderStyle: 'solid',
      borderTopWidth: isFirst && !omitFirstLine ? 1 : 0,
      borderBottomWidth: isLast && omitLastLine ? 0 : 1,
      position: 'relative'
    },
    radioWrapperStyle: _objectSpread(_objectSpread({}, shouldPaddingLeftBullet ? {
      paddingLeft: 5
    } : {}), hasDegradedPerformance ? {
      position: 'absolute',
      top: 20,
      left: 0
    } : {}),
    inputStyle: {
      height: '100%',
      margin: 0,
      opacity: 0,
      padding: 0,
      position: 'absolute',
      width: '100%',
      top: 0,
      left: 0,
      zIndex: disabled ? -1 : 1,
      cursor: disabled ? 'auto' : 'pointer',
      WebkitTapHighlightColor: designContext.get('colors/backgrounds/transparent').toString()
    },
    labelStyle: hasDegradedPerformance ? {
      position: 'relative',
      paddingTop: description ? 20 : 20,
      paddingBottom: description ? 20 : 25
    } : {
      alignItems: !description || isSingleLine ? 'center' : 'flex-start',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      cursor: disabled ? 'auto' : 'pointer',
      position: 'relative',
      paddingTop: 15,
      paddingBottom: 15
    },
    inlineContentStyle: {
      fontWeight: '400',
      color: descriptionTextColor
    },
    inlineDescriptionStyle: _objectSpread(_objectSpread({
      color: descriptionTextColor
    }, descriptionTextStyle), {}, {
      marginLeft: 10,
      WebkitFontSmoothing: 'antialiased'
    }),
    articleWrapperStyle: hasDegradedPerformance ? {
      paddingLeft: 35
    } : {
      paddingRight: !aside ? 0 : isSingleLine ? 15 : 20,
      flexShrink: 'inherit',
      paddingLeft: hideBullet ? 0 : shouldPaddingLeftBullet ? 10 : 15,
      flexGrow: 1,
      flexDirection: isSingleLine ? 'row' : 'column'
    },
    asideWrapperStyle: {
      opacity: disabled ? 0.2 : 1
    },
    newLineDescriptionStyle: {},
    // Needed for stylesheet overrides
    contentStyle: _objectSpread({
      paddingBottom: 25
    }, hasContentPadding ? {
      paddingLeft: 35,
      paddingRight: 35
    } : {}),
    titleStyle: _objectSpread(_objectSpread({
      margin: 0,
      paddingLeft: 0,
      paddingRight: 0,
      boxSizing: 'border-box',
      flexShrink: 0,
      textRendering: 'geometricPrecision',
      WebkitFontSmoothing: 'antialiased',
      wordBreak: 'break-word',
      textAlign: 'left'
    }, designContext.get('radio/title-text-style').styles()), {}, {
      color: designContext.get('radio/title-text-color', {
        interactiveState: disabled ? 'disabled' : 'default'
      }).toString()
    }),
    paragraphSecondaryCorrectFootprintLightStyle: _objectSpread(_objectSpread({
      color: descriptionTextColor
    }, descriptionTextStyle), {}, {
      margin: 0,
      WebkitFontSmoothing: 'antialiased',
      textAlign: 'left',
      wordBreak: 'break-word'
    }),
    spacerVerticalSmallStyle: {},
    // Needed for stylesheet overrides
    headerWrapperStyle: {},
    inlineDescriptionWrapperStyle: {},
    inlineDescriptionTextStyle: {}
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map